export default {
	'permission-type': 'Tipo de permiso',
	'read-only': 'Solo lectura',
	'read-and-write': 'Leer y escribir',
	'no-permission': 'Sin permiso',
	Users: 'Usuarios',
	'the-role': 'El papel?',
	'deleting-role-alert': 'Eliminar un rol eliminará a todos los usuarios del rol.',
	'the-user': 'El usuario?',
	
	'add-user': 'Agregar usuario',
	'edit-user': 'Editar usuario',

	'password-note': 'Nota: deje los campos de contraseña vacíos si no desea cambiarla',

	permissions: {
		'managing-purchase': 'Oferta',
		'managing-purchase-simulation': 'Ofrece simulación',
		'managing-receives': 'Compras',
		sales: 'Ventas',
		'managing-inventory': 'Inventario',
		'managing-items': 'Artículos',
		'managing-accounts': 'Cuentas',
		'managing-users': 'Usuarios',
		statistics: 'Estadística',
		'fiscal-years': 'Años fiscal',
		'material-journal': 'Diario de material',
		'managing-settings': 'Ajustes',

		'managing-production-orders': 'Órdenes de producción',
		'managing-order-results': 'Resultados de pedidos',
		'managing-items-statement': 'Declaración de artículos',
		'managing-experimental-simulation': 'Simulación experimental',
		'managing-material-simulation': 'Simulación de material',
		'managing-receiving-journals': 'Gestión de diarios de recepción',
		'delivery-journals': 'Diarios de entrega'
	},

	'permissions-description': {
		'managing-purchase': 'Permiso para administrar ofertas',
		'managing-purchase-simulation': 'Permiso para administrar la simulación de ofertas',
		'managing-receives': 'Permiso para administrar compras',
		sales: 'Permiso para gestionar contratos y entregas',
		'managing-inventory': 'Permiso para gestionar diarios de materiales, inventario y estados de artículos',
		'managing-items': 'Permiso para gestionar artículos',
		'managing-accounts': 'Permiso para gestionar cuentas',
		'managing-users': 'Permiso para gestionar roles y usuarios',
		'fiscal-years': 'Permiso para administrar años fiscales',
		'material-journal': 'Permiso para usar Material Journal para cambiar a los propietarios',
		'managing-settings': 'Permiso para administrar la configuración',

		'managing-production-orders': 'Autorización para gestionar órdenes de producción',
		'managing-order-results': 'Permiso para gestionar los resultados del pedido',
		'managing-items-statement': 'Declaración de permiso para gestionar elementos',
		'managing-experimental-simulation': 'Permiso para gestionar la simulación experimental',
		'managing-material-simulation': 'Permiso para gestionar la simulación de material',
		'managing-receiving-journals': 'Permiso para gestionar diarios de recepción',
		'delivery-journals': 'Permiso para gestionar diarios de entrega'
	}
}